<script setup>
import { computed, defineProps, ref, watch } from "vue";
import AudioPlay from "./components/AudioPlay.vue";
import { useListenConfigStore } from "@/hooks/useListenConfigStore";
import store from "@/js/store";

const listenStore = useListenConfigStore();

const props = defineProps(["linkContent"]);

const active = ref(1);

const choiceQuestionList = ref([]);

const dataList = ref([]);

const knowledgePoints = ref();

const audio_name = ref("");

const analyze = ref(); //解析

const originalText = ref(); //原文

const fontSize = computed(() => listenStore.fontSize);

const ossUrl = `${store.getOEMBASE() || ""}grammar_content/`; //音频前缀路径

watch(
  () => props.linkContent,
  (newval) => {
    if (newval) {
      analyze.value = JSON.parse(props.linkContent.analyze);
      originalText.value = JSON.parse(props.linkContent.originalText);
      knowledgePoints.value = props.linkContent.knowledgePoints;
      choiceQuestionList.value = analyze.value.questionDataList;
      dataList.value = originalText.value;
      audio_name.value = analyze.value.materialAudioUrl;
      for (const item of dataList.value) {
        item.showTranslate = listenStore.showTranslate;
      }
    }
  }
);

//监听中文翻译显示状态改变
watch(
  () => listenStore.showTranslate,
  (newval) => {
    if (dataList.value.length > 0) {
      for (const item of dataList.value) {
        item.showTranslate = newval;
      }
    }
  }
);

const audioPlayRef = ref()

const moveX = ref()
const changeActive = (val) => {
  active.value = val;
  if(active.value === 3){
    audioPlayRef.value.audioRef.pause()
    moveX.value = audioPlayRef.value.currentProgressRef.style.width
  }else{
    if(audioPlayRef.value.audioRef.paused){
      audioPlayRef.value.currentProgressRef.style.width = moveX.value
    }
  }
};
</script>

<template>
  <div class="container-box" :class="fontSize">
    <div class="tab-box">
      <div class="tab-box_item" :class="{ active: active === 1 }" @click="changeActive(1)">
        解析
      </div>
      <div class="tab-box_item" :class="{ active: active === 2 }" @click="changeActive(2)">
        原文
      </div>
      <div class="tab-box_item" :class="{ active: active === 3 }" @click="changeActive(3)">
        知识点
      </div>
    </div>
    <AudioPlay ref="audioPlayRef" v-show="active !== 3" :audio-name="audio_name" class="audio-box" />

    <template v-if="active === 1">
      <div class="item-card">
        <div class="choice-question-box">
          <div v-for="(item, index) in choiceQuestionList" :key="item.id" class="card">
            <div class="title">{{ item.question }}</div>
            <div class="card-option">
              <div
                v-for="(opt, optIdx) in item.optionList"
                :key="opt.optionNumber"
                class="item-option"
              >
                <img
                  v-if="opt.optionNumber === item.answer"
                  class="icon"
                  src="@/assets/listening/icon-success.svg"
                  alt=""
                />
                <img
                  v-if="opt.optionNumber !== item.answer && opt.optionNumber === item.studentAnswer"
                  class="icon"
                  src="@/assets/listening/icon-mistake.svg"
                  alt=""
                />
                <span
                  v-if="opt.optionNumber !== item.answer && opt.optionNumber !== item.studentAnswer"
                  class="circle"
                ></span>
                <!--optionFormat 1=纯文本，2=图片-->
                <div
                  v-if="opt.optionFormat == 1"
                  :class="{
                    error:
                      opt.optionNumber !== item.answer && opt.optionNumber === item.studentAnswer,
                    success: opt.optionNumber === item.answer,
                  }"
                >
                  {{ opt.optionContent }}
                </div>
                <img
                  v-if="opt.optionFormat == 2"
                  class=""
                  alt=""
                  :src="`${ossUrl}${opt.optionContent}`"
                />
              </div>
            </div>
            <div class="answer-box">
              <div class="answer-box_left">
                <img src="@/assets/listening/icon-analysis.svg" alt="" />
                <span
                  >正确答案：<label class="success">{{ item.answer }}</label></span
                >
              </div>
              <div class="answer-box_right">
                你的答案：<span :class="item.studentAnswer===item.answer?'success':'error'">{{ item.studentAnswer }}</span>
              </div>
            </div>
            <div class="analysis">
              {{ item.analysis }}
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="active === 2">
      <div class="dialogue-box" v-for="(item, index) in dataList" :key="index">
        <span v-show="item.role" class="dialogue-box_role">{{ item.role }}</span>
        <div class="dialogue-box_sentence">
          <span v-for="(s, idx) in item.paragraphText" :key="idx" class="sentence">{{
            s.sentenceText
          }}</span>
          <div class="translate" v-if="item.showTranslate">
            <span v-for="(s, idx) in item.paragraphText" :key="idx">{{
              s.sentenceTranslation
            }}</span>
          </div>
        </div>
      </div>
    </template>

    <template v-if="active === 3">
      <div class="knowlage-content">
        <div class="knowlage-content_item" v-html="knowledgePoints"></div>
        <!--        <div class="knowlage-content_item">
          <div class="title">重点词汇：</div>
          <div class="sub-title">订餐常用表达：</div>
          <ul class="knowlage-content_item_content">
            <li>1. I'd like to order ...<span>（我想要订购……）</span></li>
            <li>1. I'd like to order ...<span>（我想要订购……）</span></li>
          </ul>
        </div>-->
      </div>
    </template>
  </div>
</template>

<style scoped lang="less">
@import "components/ThemeTag/fontSize";
.container-box {
  .tab-box {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5rem;
    font-size: 1rem;
    position: sticky;
    top: 0;
    background-color: var(--page-inner-bg);
    z-index: 9;
    &_item {
      line-height: 1.4rem;
      color: var(--text-color);
    }
    .active {
      color: var(--tab-active);
      font-weight: 500;
      position: relative;
      &:after {
        content: "";
        width: 100%;
        height: 0.25rem;
        border-radius: 0.13rem;
        background-color: var(--tab-active);
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -0.3rem;
      }
    }
  }
  .audio-box {
    margin-top: 1rem;
    margin-bottom: 0.64rem;
  }
  .choice-question-box {
    .card {
      padding: 0;
      margin: 0;
      padding: 0.95rem;
      background-color: var(--choice-card-bg-color);
      list-style: none;
      border-radius: 1rem;
      margin-top: 0.64rem;

      .title {
        color: var(--text-title-color);
        font-size: var(--step1-title);
        font-weight: 500;
      }
      .item-option {
        font-size: var(--step1-item-text);
        font-weight: 400;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 0.38rem;
        color: var(--text-color);
        .circle,
        .circle-active {
          width: 1.15rem;
          height: 1.15rem;
          border-radius: 50%;
          border: 1px solid var(--circle-color);
          display: inline-block;
        }
        .icon {
          width: 1.15rem;
          height: 1.15rem;
        }
      }
    }
    .card-option {
      gap: 0.76rem;
      display: flex;
      flex-direction: column;
      margin: 0.8rem 0 0;
    }
    .answer-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      &_left {
        display: inline-flex;
        align-items: center;
        gap: 0.64rem;
        color: var(--text-color);
      }
      &_right {
        color: var(--text-gray-color);
      }
      img {
        width: 2.75rem;
        height: 3.1em;
      }
    }
    .analysis {
      color: var(--text-gray-color);
      font-size: var(--step4-analysis-text);
      line-height: 1.4rem;
    }
  }
  .dialogue-box {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 0.8rem;
    margin-bottom: 0.8rem;
    font-weight: 400;
    &_role {
      color: #ff8c00;
      font-size: 1.1rem;
      display: inline-block;
      min-width: 2.2rem;
      line-height: 1.7;
    }
    &:nth-child(2n) {
      .dialogue-box_role {
        color: #04976b;
      }
    }
    &_sentence {
      //text-indent: 1.8rem;
      position: relative;
      font-size: var(--step3-text);
      color: var(--text-color);
      line-height: 1.7;
      img {
        width: 1.3rem;
        height: 1.3rem;
        vertical-align: middle;
        margin-right: 0.3rem;
      }
      .translate {
        color: #898c90;
        font-size: var(--step3-translate-text);
        margin: 0.6rem 0 0;
      }
      .sentence{
        margin-right: 5px;
      }
    }
    .sentence-active {
      background-color: #04976b;
      color: white;
      font-weight: 500;
      padding: 0 0.3rem;
    }
  }
  .knowlage-content {
    font-size: var(--step4-konwlage-text);
    color: var(--text-color);
    margin-top: 0.64rem;
    &_item {
      margin-bottom: 0.95rem;
      line-height: 1.7;
    }
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
    .title {
      font-weight: 500;
      margin-bottom: 0.5rem;
    }
    .sub-title {
      color: #04976b;
      font-size: 0.9rem;
      margin-bottom: 0.5rem;
    }
    &_item_content span {
      color: #898c90;
    }
  }
  .success {
    color: #28c840;
  }
  .error {
    color: #e5481f;
  }
}
</style>
